import React, { useState, useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import './Header.css';

const Header = () => {
  const { language, toggleLanguage } = useContext(LanguageContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  return (
    <header className="header">
      <div className="logo">
        <img src="/images/logo.png" alt="Logo" />
        <h1>{language === 'ar' ? 'منظمة الخلد للإعمار والتنمية' : 'Alkhold Organization for Development'}</h1>
      </div>

      <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
        <ul>
          <li><a href="/">{language === 'ar' ? 'الرئيسية' : 'Home'}</a></li>
          <li><a href="/about">{language === 'ar' ? 'عن المنظمة' : 'About'}</a></li>
          <li><a href="/projects">{language === 'ar' ? 'المشاريع' : 'Projects'}</a></li>

          {/* ✅ New Policies link */}
          <li><a href="/policies">{language === 'ar' ? 'السياسات والإجراءات' : 'Policies & Procedures'}</a></li>

          <li><a href="/contact">{language === 'ar' ? 'التواصل' : 'Contact'}</a></li>
        </ul>
      </nav>

      <button className="language-toggle" onClick={toggleLanguage}>
        {language === 'ar' ? 'English' : 'العربية'}
      </button>

      <button className={`menu-toggle ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <div className="menu-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
    </header>
  );
};

export default Header;
